<template>
  <div class="view" style="positon: relative">
    <div class="room" :class="{'reverse': index % 2 === 1}" v-for="(room, index) in rooms" :key="room._id" >
      <div class="text">
        <h2 v-html="room.name"></h2>
        <h3 v-if="$i18n.locale === 'fr'">{{room.description}}</h3>
        <h3 v-if="$i18n.locale === 'en'">{{room.description_en}}</h3>
        <a class="button" @click="showDetails(room)">{{$t('room.see')}}</a>
        <!-- <h3 v-html="room.subtitle"></h3> -->
      </div>
      <div class="image">
        <img :src="getImage(room.main_image._id)" v-if="images" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
// import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'Rooms',
  data () {
    return {
    }
  },
  mounted () {
    this.$store.dispatch('rooms/getRooms')
    this.$store.commit('rooms/unselect_room')
  },
  computed: {
    ...mapState({
      rooms: state => state.rooms.list,
      images: state => state.images.list
    })
  },
  methods: {
    getImage(id) {
      let path = ''
      this.images.map(i => {
        if (i._id === id) {
          path = i.source.path
        }
      })
      /*eslint-disable*/
      // console.log(path, imag)
      /*eslint-enable*/
      return path
    },
    showDetails(room) {
      this.$store.commit('rooms/select_room', room)
      this.$router.push({name: 'room'})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
.view {
  .room {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap-reverse;
    justify-content: center;
    align-content: center;
    font-weight: bold;
    background-color: white;
    width: 100%;
    color: black;
    text-align: center;
    &.reverse {
      flex-direction: row-reverse;
      flex-wrap: wrap;
    }
    .text, .image {
      flex: 1;
      max-width: 50vw;
      min-height: 450px;
      height: calc(100vh - 100px);
      max-height: 600px;
    }
    .image {
      // background-color: $light-blue;
      overflow: hidden;
      min-width: 400px;
      position: relative;
      img {
        position: absolute;
        left: 0;
        right: 0;
        pointer-events: none;
        flex-shrink: 0;
        min-width: 100%;
        max-width: 800px;
        object-fit: cover;

      }
    }
    .text {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding: 20px 50px;
      box-sizing: border-box;
      text-align: left;
      h2 {
        font-size: 50px;
        color: $dark-blue;
        margin-bottom: 0;
      }
      h3 {
        font-size: 30px;
        margin-top: 0px;
        color: $light-blue;
      }
      .button {
        margin: 80px auto;
        max-width: 150px;
      }
    }

    @media (max-width: 700px) {
      flex-direction: column-reverse;
      .text  {
        max-width: 100%;
        padding: 10px;
        min-height: 250px;
        h2 {
          margin-top: 10px;
        }
      }
      .image {
        min-width: 100px;
        width: 100%;
        max-width: 100vw;
        height:  250px;
        min-height: 250px;
        img {
          transform: translate(0, -20%);
          max-width: 100vw;
          width: 100%;
        }
      }
      &.reverse {
        flex-direction: column-reverse;
      }
    }
  }
}

</style>